<template>
  <v-container :fill-height='loading'>
    <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
    style="background:var(--background-grey); height:100vh;"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
          </v-progress-circular>
      </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <div class="add-page-head">
          <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Repeat Jobs</span>
          <span class="body-small font-weight-bold pt-1 d-block">Automate monthly or annual jobs</span>
        </div>
        <div class="app-panel" :class="{'white px-1 pb-5 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-5 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-layout :class="{'px-3 pb-3' : $vuetify.breakpoint.xsOnly, 'px-0 pb-5 ' : !$vuetify.breakpoint.xsOnly}">
            <v-flex xs8>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                :autofocus="!$vuetify.breakpoint.xsOnly"
                clearable
                v-model="search"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 offset-xs1 text-xs-right>
              <create-repeat-job-modal @pushData="pushData"></create-repeat-job-modal>
            </v-flex>
        </v-layout>
        <v-data-table
            :headers="headers"
            :items="repeatJobs"
            hide-actions
            :search="search"
            class="datatable"
          >
          <template slot="items" slot-scope="props">
            <tr @click='editRepeatJob(props.item)' style="cursor: pointer;">
              <td class="text-xs-left body-small" style="white-space: nowrap;">{{ props.item.nextRepeats }}</td>
              <td class="text-xs-left body-small">{{ props.item.clientName }}</td>
              <td class="text-xs-left body-small">{{ props.item.title}}</td>
              <td class="text-xs-left body-small">{{ props.item.schedule.frequency}}</td>
              <td class="text-xs-left body-small"><display-amount :totalAmount="props.item.amount" :totalNetAmount="props.item.totalNetAmount"></display-amount></td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
        <edit-repeat-job-modal :showEdit.sync='showEdit' @updateJobList='fetchData()' :editingRepeatJob='editingRepeatJob'></edit-repeat-job-modal>
    </div>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import CreateRepeatJobModal from '@/components/RepeatJob/CreateRepeatJobModal'
import EditRepeatJobModal from '@/components/RepeatJob/EditRepeatJobModal'
import DisplayAmount from '@/components/Shared/DisplayAmount'

export default {
  components: {
    CreateRepeatJobModal,
    EditRepeatJobModal,
    DisplayAmount
  },
  data () {
    return {
      search: '',
      pagination: {},
      headers: [
        { text: 'Next', value: 'nextRepeats', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Client Name', value: 'clientName', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Job Description', value: 'title', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Frequency', value: 'frequency', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Amount', value: 'amount', align: 'left', class: 'body-2 font-weight-bold' }
      ],
      user: this.$store.getters.user,
      repeatJobs: [],
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      editingRepeatJob: {},
      showEdit: false
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    clearRepeatingJob () {
      this.editingRepeatJob = ''
    },
    editRepeatJob (repeatJob) {
      this.editingRepeatJob = repeatJob
      this.showEdit = true
    },
    fetchData () {
      this.repeatJobs = []
      this.$store.commit('setLoading', true)

      firebase.database().ref('repeat-jobs/' + this.user.group).once('value')
        .then(data => {
          this.$store.commit('setLoading', false)
          const obj = data.val()
          for (let key in obj) {
            this.repeatJobs.push(obj[key])
          }
        })
        .catch(
          (error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        )
      // Get current zulu time
      // const today = new Date()
      // const nowZulu = today.toISOString()

      // firebase.database().ref('repeat-queue/').orderByChild('zuluRepeats').endAt(nowZulu).once('value')
      //   .then(snapshot => {
      //     let newJob = {}
      //     let ref
      //     let updates = {}
      //     let clientName
      //     let title
      //     let amount
      //     let groupId
      //     let sourceRepeatJob
      //     let schedule
      //     let queueItemRef

      //     snapshot.forEach(childSnapshot => {
      //       ref = firebase.database().ref(`lists/${childSnapshot.val().group}/list3`).push().key
      //       clientName = childSnapshot.val().clientName
      //       title = childSnapshot.val().title
      //       amount = childSnapshot.val().amount
      //       clientName = childSnapshot.val().clientName
      //       groupId = childSnapshot.val().group
      //       sourceRepeatJob = childSnapshot.val().rJob
      //       schedule = childSnapshot.val().schedule
      //       queueItemRef = childSnapshot.key

      //       newJob = {
      //         id: ref,
      //         clientName: clientName,
      //         title: title,
      //         amount: amount,
      //         contact: '',
      //         chase_date: '',
      //         start_date: '',
      //         deadline_date: '',
      //         invoice_ref: '',
      //         invoiced_date: '',
      //         paid_date: '',
      //         invoiceId: '',
      //         creatorId: '',
      //         listId: 3,
      //         order: 0
      //       }
      //       updates[`lists/${groupId}/list3/${ref}`] = newJob
      //       updates[`repeat-jobs/${groupId}/${sourceRepeatJob}/schedule/lastCreated`] = nowZulu
      //       updates[`repeat-queue/${queueItemRef}/zuluRepeats`] = schedule
      //     })
      //     console.log('asdadadsdsa', snapshot.numChildren())
      //     console.log('updates', updates)

      //     // return firebase.database().ref().update(updates);
      //   })
      //   .catch(
      //     (error) => {
      //       this.$store.commit('setError', error)
      //       // this.$store.commit('setLoading', false)
      //     }
      //   )
    },
    pushData (job) {
      this.repeatJobs.push(job)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
